import React from "react";
import { cn } from "../../../libs/utils";
import { BATCH_STATUS } from "../batchDerived";

const fillStyles = {
  [BATCH_STATUS.CREATED]: "bg-slate-200",
  [BATCH_STATUS.WIP]: "bg-emerald-500",
  [BATCH_STATUS.HOLD]: "bg-rose-500",
  [BATCH_STATUS.COMPLETED]: "bg-emerald-600",
};

const BatchProgressBar = ({ progress = 0, status, className, showLabel = true }) => {
  const clamped = Math.max(0, Math.min(100, progress));

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div className="h-2 w-full max-w-[140px] overflow-hidden rounded-full bg-slate-100">
        <div
          className={cn("h-full rounded-full transition-all", fillStyles[status] || "bg-slate-400")}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && (
        <span className="w-9 shrink-0 text-xs font-semibold text-slate-600">{clamped}%</span>
      )}
    </div>
  );
};

export default BatchProgressBar;
